<template>
    <PostViewPage :data="data" />
</template>
<script>
import { getPostDetail } from '@/api';
import PostViewPage from '@/views/common/PostViewPage.vue';

export default {
    components: {
        PostViewPage,
    },
    data() {
        return {
            data: {},
        };
    },
    methods: {
        async getData() {
            const { data } = await getPostDetail('/bridging/activity/detail', this.$route.params.id);
            if (!data) {
                const targetRoute = this.$route.path.split('/').slice(0, -1).join('/');
                this.$router.push({
                    path: targetRoute,
                    query: {
                        ...this.$route.query,
                    },
                });
            } else {
                this.data = data;
            }
        },
    },
    async mounted() {
        this.getData();
    },
    watch: {
        async $route() {
            this.getData();
        },
    },
};
</script>
